import { localGetData } from "../utils/utils";

export function useSpecificSetup(oriId) {
  if (!oriId) {
    return {};
  }
  try {
    const localStoreSpecificSetup = localGetData(`specific-setup-${oriId}`) || {};
    const { setupLists: specificSetupLists } = localStoreSpecificSetup || {};
    return specificSetupLists || {};
  } catch (error) {
    console.error('Failed to parse specific setup from localStorage:', error);
    return {};
  }
}